<template>
	<v-select
		class="nav-select"
		:value="value"
		:options="options"
		:placeholder="placeholder"
		:allowEmpty="false"
		:internalSearch="false"
		:showLabels="false"
		@search-change="search"
		@select="select"
		:track-by="trackBy"
		label="name"
	>
		<span slot="noResult">Inga resultat</span>
		<span
			slot="caret"
			slot-scope="{ toggle }"
			class="caret"
			@mousedown.prevent.stop="toggle()"
		><i class="fas fa-caret-down caret-inner"></i
		></span>
		<template #afterList v-if="showLoadMore">
			<div class="p-2" style="text-align: center; background: #f5f5f5;">
				<span class="LoadMoreButton p-1 px-3" v-if="!loading" @click="onLoadMore">Ladda fler</span>
			</div>
		</template>
	</v-select>
</template>

<script>
export default {
	props: {
		options: {
			type: Array
		},

		placeholder: {
			type: String,
			default: () => 'Välj'
		},

		value: {
			type: Object
		},

		trackBy: {
			type: String,
			default: 'id'
		},

		showLoadMore: {
			type: Boolean,
			default: false
		},

		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		select(selection) {
			this.$emit('select', selection);
		},

		search(search) {
			this.$emit('search', search);
		},

		onLoadMore() {
			this.$emit('on-load-more');
		}
	}
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";
$multiselect-border-color: $light-grey;
.LoadMoreButton {
	cursor: pointer;
	background-color: #ef7c21;
	color: white;
	border-radius: 3px;
	font-size: 12px;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ee7515;
		transition: background-color 0.3s ease;
	}
}

.multiselect__content-wrapper {
	overflow-y: auto !important;
	width: auto !important;
	min-width: 100% !important;
	max-width: 200% !important;
}

.multiselect.nav-select {
  width: 100%;
  max-height: $select-height;
  min-height: $select-height;
}
.multiselect.nav-select .multiselect__tags {
  background-color: $multiselect-background-color;
  border-color: $multiselect-border-color;
  border-radius: 15px;
  color: $dark;
  font-size: 12px;
  min-height: $select-height;
  max-height: $select-height;
  padding-left: 10px;
  padding-top: calc((#{$select-height} - 24px) / 2);
  overflow: hidden;
  white-space: nowrap;
}
.multiselect.nav-select.multiselect--active .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.multiselect.nav-select .multiselect__input {
  background-color: $multiselect-background-color;
  color: $dark;
  top: 1px;
  padding: 0;
  margin: 0;
  font-size: 12px;
}
.multiselect.nav-select .multiselect__input::placeholder {
  color: lightgrey !important;
  font-size: 12px;
}
.multiselect.nav-select .multiselect__placeholder {
  color: $dark;
  margin-bottom: 0px;
}
.multiselect.nav-select .multiselect__content-wrapper {
  background-color: $multiselect-border-color;
  border-color: $multiselect-border-color;
  overflow: hidden;
}
.multiselect.nav-select .multiselect__content .multiselect__element {
  background-color: $multiselect-background-color;
  color: $dark;
  font-size: 12px;
}
.multiselect.nav-select .multiselect__option {
  padding: 4px 0px 0px 5px;
  min-height: 0px;
  height: 22px;
}
.multiselect.nav-select .multiselect__option--selected {
  background: $info-active;
  color: $white;
}
.multiselect.nav-select .multiselect__option--highlight {
  background-color: $info;
}
.multiselect.nav-select .multiselect__single {
  background-color: $multiselect-background-color;
  padding: 0;
  margin: 0;
  top: 2px;
  font-size: 12px;
  overflow: hidden;
  width: 100%;
}
.multiselect.nav-select .multiselect__select {
  height: calc(#{$select-height} - 2px);
  width: 22px;
  padding: 0;
}
.multiselect.nav-select
  .multiselect__option--selected.multiselect__option--highlight {
  background-color: $info;
  color: $white;
}
.multiselect.nav-select .caret {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: calc(((#{$select-height} - 24px) / 2) + 1px) 9px 0px 5px;
  height: 100%;
  color: $info;
  cursor: pointer;
  border-left: 1px solid $multiselect-border-color;
}
.multiselect.nav-select .caret-inner {
  transition-duration: 0.2s;
}
.multiselect.nav-select.multiselect--active .caret .caret-inner {
  transition-duration: 0.2s;
  transform: rotate(180deg);
}
</style>
